// src/lib/bentoUtils.js
/**
 * Fetches data from a Bento API endpoint
 * @param {string} url - The full Bento API URL (e.g., from gammaStreamConfigPresets.bentoUrl)
 * @returns {Promise<any>} - The parsed Bento API response
 */
export async function fetchBentoData(url) {
  try {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Bento API request failed: ${res.status} ${res.statusText}`);
    }
    return await res.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('fetchBentoData error:', error);
    throw error;
  }
}
